<script setup lang="ts">
import ServiceManagement from "@/views/playground/planner/business-management/service-management/ServiceManagement.vue";
</script>

<template>
  <service-management></service-management>
</template>

<style scoped></style>
